<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/useradmin/listusers" class="blue-grey-text text-darken-4 strong">Users</router-link>
        >
        <span>Edit User</span>
      </section>
    </article>
    <h4>Edit User</h4>
    <article class="row">
      <section class="input-field col s4">
        <input disabled type="text"
               placeholder="John Smith"
               :value="analyst.first_name + ' ' +analyst.last_name"
        >
        <label disabled class="active">Name</label>
      </section>
      <section class="input-field col s4">
        <input disabled type="text"
               placeholder="jsmith@fool.com"
               v-model="analyst.email"
        >
        <label disabled class="active">Email</label>
      </section>
      <section class="input-field col s2">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="analyst.active"
                   :disabled="!$auth.hasRoles('admin')"
            >
            <span>Active</span>
          </label>
        </p>
      </section>
      <section class="input-field col s2">
        <p>
          <label>
            <input type="checkbox"
                   class="filled-in"
                   v-model="analyst.is_tester"
                   :disabled="!$auth.hasRoles('admin')"
            >
            <span>Tester</span>
          </label>
        </p>
      </section>
    </article>
    <article class="row">
        <h5>Assign Roles</h5>
        <div v-for="role in roles" :key="role.id" class="col s4">
          <div class="card horizontal">
            <div class="card-stacked">
              <div class="card-content">
                  <label>
                    <input type="checkbox" class="filled-in" :value="role.name" v-model="analyst.roles">
                    <span class="strong">{{ role.name }}</span>
                    <span class="helper teal-text text-lighten-3" v-if="['analyst', 'farm-team', 'adp'].includes(role.name)"> *required</span>
                  </label>
                  <p>{{ role.description }}</p>
              </div>
            </div>
          </div>
        </div>        
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light teal accent-4 right"
               type="submit"
               value="Submit"
               @click.prevent="saveUser"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EditUser',
  props: {},
  data() {
    return {
      roles: [],
      analyst: {
        roles: [],
      },
      validationErrorMessage: 'Please populate all required fields',
    };
  },
  computed: {
    analystId() {
      return Number(this.$route.query.analyst_id);
    },
  },
  watch: {},
  methods: {
    resetForm() {
      this.fetchAnalyst();
    },
    validateForm() {
      return ([
        this.analyst.roles.length,
      ].every(arg => Boolean(arg)));
    },
    async fetchAnalyst() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/analyst/${this.analystId}/`);
      this.analyst = data;
    },
    async fetchRoles() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/roles/`);
      this.roles = data.filter(role => role.managers.filter(manager => this.$auth.user.roles.includes(manager)).length);
    },
    async saveUser() {
      if (!this.validateForm()) {
        return this.toast(this.validationErrorMessage, 'pink');
      }
      const { data } = await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/analysts/analyst/${this.analystId}/`, {
        email: this.analyst.email,
        roles: this.analyst.roles,
        active: this.analyst.active,
        is_tester: this.analyst.is_tester,
      });
      this.toast(`Updated user ${data.name} in Fool IQ!`, 'green');
      this.resetForm();
    },
  },
  async mounted() {
    await this.fetchAnalyst();
    await this.fetchRoles();
  },
};
</script>
